import React, { useState } from "react";
import "./AuthGrid.scss";
import SideMenu from "../SideMenu/SideMenu";
import Header from "../../moleculesv2/Header/Header";

const AuthGrid = ({ children }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <div className="AuthGrid">
            {mobileMenuOpen && (
                <div className="menu-overlay" onClick={() => setMobileMenuOpen(false)} />
            )}
            <div className="menu">
                <SideMenu
                    mobileOpen={mobileMenuOpen}
                    onMobileClose={() => setMobileMenuOpen(false)}
                />
            </div>
            <header className="header">
               <Header setMobileMenuOpen={setMobileMenuOpen} />
            </header>
            <div className="content">{children}</div>
        </div>
    );
};

export default AuthGrid;